<template>
  <ankh-list :padding="0" :show-btn-group="!isPlain" v-bind="$attrs">
    <template #search-form>
      <el-form-item :label="$t('无操作')">
        <el-input :placeholder="$t('无操作')" clearable v-model="searchForm.offBright" />
      </el-form-item>
      <el-form-item :label="$t('协议代码')">
        <el-input :placeholder="$t('协议代码')" clearable v-model="searchForm.protocolCode" />
      </el-form-item>
      <el-form-item :label="$t('创建日期')">
        <date-time-range-picker
            :start-time.sync="searchForm.startCreateTime"
            :end-time.sync="searchForm.endCreateTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch()">{{$t('查询')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #btn-group>
      <el-button size="small" type="primary" @click="handleShowFormDialog()">{{$t('新增')}}</el-button>
      <el-button size="small" type="primary" @click="$emit('export')">{{$t('导出')}}</el-button>
      <el-button size="small" type="danger" @click="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          :search-params="searchForm"
          @query="loadList"
          @selection-change="selection = $event"
          :data="tableData">
        <el-table-column type="selection" width="50" />
        <el-table-column type="index" :label="$t('序号')" width="50" />
        <el-table-column :label="$t('无操作-关闭亮屏')" prop="offBright">
          <template v-slot="{row}">
            {{row.offBright}} s
          </template>
        </el-table-column>
        <el-table-column :label="$t('协议代码')">
          <template v-slot="{row}">
            <div class="flex" style="column-gap: 6px" v-if="row.protocolCode">
              <el-link :underline="false" type="primary">{{ row.protocolCode || "" }}</el-link>
              <i class="el-icon-copy-document" @click="handleCopy(row)" id="copyBtn" :data-clipboard-text="row.protocolCode" />
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('创建日期')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('备注')" prop="remark" />
        <el-table-column :label="$t('操作')" v-if="!isPlain">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link :underline="false" type="primary" @click="handleShowFormDialog(row)">{{$t('编辑')}}</el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
的
    <template #other>
      <!-- 新增/编辑-->
      <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="handleReset">
        <template #title>
          <h4>{{ isEdit ? "编辑" : "新增" }}</h4>
        </template>

        <el-form label-width="auto" ref="form" :rules="rules" :model="formData">
          <el-form-item :label="$t('操作')" prop="offBright">
            <el-input :placeholder="$t('无操作')" v-model="formData.offBright">
              <template #append>s</template>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('无操作')" prop="protocolCode">
            <div class="flex gap-6">
              <el-input :placeholder="$t('协议')" v-model="formData.protocolCode" />
<!--              <el-button type="primary" size="small" @click="buildProtocol">生成协议</el-button>-->
            </div>
          </el-form-item>
          <el-form-item :label="$t('协议')" prop="remark">
            <el-input :placeholder="$t('备注')" type="textarea" :rows="4" v-model="formData.remark" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button type="primary" @click="handleAddOrEditSubmit">{{$t('确定')}}</el-button>
          <el-button @click="handleReset">{{$t('重置')}}</el-button>
        </template>
      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import {copyText} from "@/utils/copy";
import {getProtocol} from "@/utils/protocol";
import {resetEmpty} from "@/utils/common";
import AnkhList from "@/components/list/AnkhList.vue";
import {exportExcel} from "@/utils/export";

export default {
  name: "LightSet",
  components: {AnkhList, DateTimeRangePicker, TableList},
  props: {
    isPlain: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      tableData: [],
      searchForm: {
        offBright: null
      },
      selection: [],
      showDialog: false,
      formConfig: [
        {label: "无操作", prop: "offBright", type: "number"},
        {label: "协议代码", prop: "protocolCode", type: "text"},
        {label: "备注", prop: "remark", type: "textarea", rows: 5}
      ],
      formData: {
        offBright: null,
        protocolCode: null,
        remark: null,
      },
      rules: {
        offBright: [
          {required: true, message: this.$t('请输入无操作'), trigger: 'blur'},
          // {pattern: /^[1-9]\d*$/, message: '请输入大于0的整数', trigger: 'blur'}
        ],
        protocolCode: {required: true, message: this.$t('协议不能为空'), trigger: 'blur'},
      },
      isEdit: false,
      currentRow: {}
    }
  },
  methods: {
    // 导出
    handleExport() {
      const codes = this.selection.map(item => item.code);
      exportExcel(codes, this.$api.common.exportBrightSet);
    },

    // 构建协议
    buildProtocol() {
      try {
        const val = this.formData.offBright;
        if(!val || isNaN(Number(val))) {
          this.$message.error(this.$t('请输入正确的无操作时间'));
          return;
        }
        const prefix = "ee080200"
        this.formData.protocolCode = getProtocol(prefix, Number(val), 2);
      } catch (e) {
        console.error("生成协议失败", e);
      }
    },

    // 查询
    handleSearch() {
      if(this.searchForm.offBright && typeof this.searchForm.offBright !== 'number') {
        this.$message.warning(this.$t('无操作时间必须为数字'));
        return;
      }
      this.$refs.list.handleSearch();
    },

    // 复制
    handleCopy() {
      copyText("#copyBtn");
    },

    // 新增\编辑
    handleAddOrEditSubmit() {
      this.$refs.form.validate(async valid => {
        if(!valid) return;
        try {
          let data = {...this.formData};
          const action = this.$api.brightSet[this.isEdit ? 'update' : 'add'];
          if(this.isEdit) {
            data = Object.assign(this.currentRow, data);
            delete data.createTime;
            delete data.updateTime;
          }
          await request(action, data);
          this.$message.success(this.$t('操作成功'));
          this.showDialog = false;
          this.$refs.list.handleRequest();
        } catch (e) {
          console.log(e);
        }
      })
    },

    // 重置
    handleReset() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData)
    },

    handleShowFormDialog(row) {
      if(row) {
        this.currentRow = {...row};
        for (const key in this.formData) {
          this.formData[key] = row[key];
        }
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.showDialog = true;
    },

    async handleBatchDelete() {
      try {
        const codes = this.selection.map(i => i.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }
        await requestByTip(this.$api.brightSet.batchDelete, codes, {isJson: true}, {message: this.$t('您现在正在进行批量删除操作, 是否继续?')});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.brightSet.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async loadList(params, setTotal) {
      try {
        const res = await request(this.$api.brightSet.list, params);
        this.tableData = res.brightSets;
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.log(e);
      }
    }
  },
  watch: {
    selection: {
      handler(list) {
        const codes = list.map(i => i.code);
        this.$emit("select", {brightSetCodes: codes});
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
